// @flow

import React from 'react'
import { StyleSheet, css } from 'lib/paypalphrodite'
import { Container, Row, Col, Text } from '@paypalcorp/pp-react'

type Props = {
  bank: any,
  isMobile: boolean,
}

const styles = StyleSheet.create({
  bankContainer: { paddingLeft: '0' },
  bankInfo: { margin: '0 0 0 20px' },
  bankInfoMobile: { margin: '0 0 0 35px' },
})

const BankDetails = (props: Props) => {
  const { bank, isMobile } = props
  const cardArtClasses = null

  return (
    <Container className={css(styles.bankContainer)}>
      <Row>
        <Col xs={1}>
          <img alt="" className={cardArtClasses} src={bank.src} width={50} />
        </Col>
        <Col xs={11}>
          <Text
            size="md"
            regular
            className={css(isMobile ? styles.bankInfoMobile : styles.bankInfo)}
          >
            {bank.title}
          </Text>
          <Text
            size="sm"
            regular
            className={css(isMobile ? styles.bankInfoMobile : styles.bankInfo)}
          >
            {bank.accountType}
          </Text>
        </Col>
      </Row>
    </Container>
  )
}

export default BankDetails
